export default __webpack_public_path__ + "static/media/VividLogo.f124fd23.svg";